import React from 'react';
// logic
import useTicketsFilters from '../components/tickets-list/use-tickets-filters';
import useTicketsList from '../components/tickets-list/use-tickets-list';
// components
import TicketsListToolbar from '../components/tickets-list/tickets-list.toolbar';
import PortalContent from '../ui/portal/portal-content';
import TicketsList from '../components/tickets-list/tickets-list';

const TicketsListPage = () => {
  const filtersData = useTicketsFilters();
  const { selectedFilters } = filtersData;
  const ticketsListData = useTicketsList({ selectedFilters });

  const { lastUpdate } = ticketsListData;

  return (
    <>
      <PortalContent>
        <TicketsListToolbar lastUpdate={lastUpdate} filtersData={filtersData} />
      </PortalContent>
      <TicketsList ticketsListData={ticketsListData} />
    </>
  );
};

export default TicketsListPage;
